import React from 'react'
import { Text } from '@amzn/storm-ui'
import { EmptyResultsContainer } from '../../manage_shared.styles'

interface AdvertisersNoResultsBodyProps {
  noDataBodyLabel: string
  noDataHeaderLabel: string
}

export const AdvertisersNoDataBody: React.FunctionComponent<AdvertisersNoResultsBodyProps> = (props: AdvertisersNoResultsBodyProps): JSX.Element => {
  const { noDataBodyLabel, noDataHeaderLabel } = props

  return (
    <EmptyResultsContainer>
      <Text textColor="base" type="h3" withMargin>
        {noDataHeaderLabel}
      </Text>
      <Text textColor="secondary">{noDataBodyLabel}</Text>
    </EmptyResultsContainer>
  )
}
